import { Flex, Tag } from 'antd';
import { SortOrder } from 'antd/es/table/interface';

import { formatNumber } from '@/lib/helpers/formatNumber';
import { formatSecondsToTime } from '@/lib/helpers/formatSecondsToTime';
import prepareDate from '@/lib/helpers/prepareDate';
import { ICategory } from '@/ts';

const singleMonitorCategoriesColumns = [
	{
		title: 'Date/time',
		dataIndex: 'created_at',
		key: 'created_at',
		sorter: true,
		sortDirections: ['ascend', 'descend', 'ascend'] as SortOrder[],
		width: 150,
		// flex: true,
		// ellipsis: true,
		// hidden: true,
		render: (_: any, record: ICategory) => {
			return (
				<>
					{record?.created_at
						? prepareDate('' + record?.created_at)
						: 'no date'}
				</>
			);
		},
	},
	{
		title: 'Title',
		dataIndex: 'title',
		key: 'title',
		// sorter: true,
		ellipsis: true,
		width: 200,
		flex: true,
		render: (_: any, record: ICategory) => {
			return <>{record.name}</>;
		},
	},
	{
		title: 'IAB',
		dataIndex: 'iab_categories',
		key: 'iab',
		ellipsis: true,
		width: 120,
		render: (_: any, record: ICategory) => {
			const hasManyCategories = record?.iab_categories?.length > 1;
			return record?.iab_categories?.[0] ? (
				<>
					<Tag color="blue">{record?.iab_categories?.[0]?.name}</Tag>{' '}
					{hasManyCategories
						? `+ ${record?.iab_categories?.length - 1} other(s)`
						: ''}
				</>
			) : (
				'-'
			);
		},
	},
	{
		title: 'Creators',
		dataIndex: 'creators_amount',
		key: 'creators_amount',
		width: 100,
		// ellipsis: true,
		render: (_: any, record: ICategory) => {
			return (
				<Flex justify="center" align="center" style={{ width: '100%' }}>
					{!record?.creators_amount
						? '-'
						: formatNumber(record?.creators_amount)}
				</Flex>
			);
			// return record.;
		},
	},
	{
		title: 'Video quantity',
		dataIndex: 'videoQuantity',
		key: 'videoQuantity',
		width: 100,
		// ellipsis: true,
		render: (_: any, record: ICategory) => {
			return (
				<Flex justify="center" align="center" style={{ width: '100%' }}>
					{!record?.video_quantity ? '-' : formatNumber(record?.video_quantity)}
				</Flex>
			);
		},
	},
	// {
	// 	title: 'Duration',
	// 	ellipsis: true,
	// 	dataIndex: 'videoDurationSeconds',
	// 	key: 'videoDurationSeconds',
	// 	render: (_: any, record: ICategory) => {
	// 		return !record?.video_duration
	// 			? '-'
	// 			: formatSecondsToTime(Number(record?.video_duration));
	// 	},
	// },
];

export { singleMonitorCategoriesColumns };
